<template>
  <div class="custom-select" :tabindex="tabindex" @blur="open = false">
    <input name="comments" type="text" autocomplete="off" id="location" @click="open = !open" @input="search"
      @keydown.down="onArrowDown" @keydown.up="onArrowUp" :placeholder="placeholder"
      :class="[open && 'open', error && 'error-border']" v-model="searchQuery" />
    <div class="items shadow" :class="{ selectHide: !open }">
      <p v-if="isLoading" class="loading">
        {{ loadingMessage }}
      </p>
      <div v-else v-for="(result, i) of results" :key="i" @click="
      
        selected = result;
      searchQuery = selected.text
        ? selected.text
        : selected.main_text;
      open = false;
      getSelected();
      " :class="{ 'is-active': i === arrowCounter }">
        <span v-if="result.text">{{ result.text }}</span><span v-else> {{ result.main_text }} </span> <br />

      </div>
    </div>
    <span  v-if="showError" style=" font-size: small; color: red;">{{ errorMessage }}</span>
  </div>
</template>

<script>
/*global google */
/*eslint no-undef: "error"*/
import axios from "axios";
let CancelToken = axios.CancelToken;
var cancelRequest;

export default {
  name: "GoogleMapsInput",
  props: {
    default: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    error: {
      required: true,
    },
    value: {
      required: true,
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  unmounted() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  data() {
    return {
      selected: "",
      open: false,
      arrowCounter: -1,
      results: [],
      isLoading: true,
      loadingMessage: "Enter keywords",
      searchQuery: "",
      showError: false,
      errorMessage: ""
    };
  },
  watch: {
    value: function (val) {
      if (!val || Object.keys(val).length === 0) {
        this.searchQuery = "";
      }
    },
  },
  methods: {

    getResults() {
      if (this.searchQuery.length < 2)
        return;
      if (cancelRequest) cancelRequest();
      axios
        .get("area/autocomplete", {
          params: {
            input: this.searchQuery,
          },
          cancelToken: new CancelToken(function executor(c) {
            cancelRequest = c; // c is the cancel function
          }),
        })
        .then((res) => {
          this.showError = false;
          this.errorMessage = "";
          if (res.data.data.length > 0) {
            this.isLoading = false;
          } else {
            this.isLoading = true;
            this.loadingMessage = "No result found ";
          }
          this.results = [];
          res.data.data.forEach((item) => {
            this.results.push({
              text: item.text,
              main_text: item.main_text,
              place_id: item.place_id,
              area: item.area,
            });
          });
        })
        .catch((err) => {
         
          this.showError = true;
          console.log("err",err)
          this.errorMessage = err.response? (err.response.data.message || "Error Heppened"):"";
        });

    },
    search() {
      this.open = true;
      this.loadingMessage = this.searchQuery ? "Loading..." : "Enter keywords";
      if (this.searchQuery) this.getResults();
      else this.isLoading = true;
    },
    getSelected() {
      console.log("111111");
      if (this.selected.area) {
        console.log("222222222");
        this.showError = false;
        this.$emit("inputSelected", this.selected.area);
        window.requestAnimationFrame(() => {
          this.$emit("validate");
        });
        console.log("222222222");
      } else {
        console.log("33333333");
        axios
          .get( "area/place-details/" + this.selected.place_id)
          .then((res) => {
            this.showError = false;
            this.errorMessage ="";
            this.$emit("inputSelected", res.data.data);
            window.requestAnimationFrame(() => {
              this.$emit("validate");
            });
          }).catch((err) => {
            this.showError = true;
            this.errorMessage = err.response.data.message || "Error Heppened";
             this.$emit("inputSelected", null);
          });
      }

    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.open = false;
        this.arrowCounter = -1;
      }
    },
    onArrowDown() {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },

  },
};
</script>


<style scoped>
p {
  margin: 0 !important;
}
input {
  width: 100%;
  max-width: none;
  padding: 16px 15px;
  font-size: 14px;
  border-radius: 10px;
  border: 1px solid #c1c5d8;
  background-color: #f7f8fa;
  float: inline-start;
  color: #202731;
}

input:focus {
  border-color: #202731;
  outline: none;
}

input::placeholder {
  color: #788e98;
}

.shadow {
  box-shadow: 0 0 6px rgba(0, 11, 138, 0.12) !important;
}
.custom-select {
  position: relative;
  width: 100%;
  text-align: start;
  outline: none;
  float: inline-start;
}

.custom-select .selected {
  background-color: #f7f8fa;
  width: 100%;
  border-radius: 10px;
  color: #788e98;
  border: 1px solid #c1c5d8;
  cursor: pointer;
  user-select: none;
  padding: 16px 15px;
  float: inline-start;
}

.custom-select .selected span {
  width: max-content;
  float: inline-start;
  font-size: 14px;
}

.custom-select .selected:after {
  position: absolute;
  content: "";
  top: 26px;
  inset-inline-end: 15px;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-color: #c1c5d8 transparent transparent transparent;
}

.custom-select .items {
  color: #fff;
  border-radius: 10px;
  overflow: hidden;
  position: absolute;
  background-color: #ffffff;
  inset-inline-start: 0;
  inset-inline-end: 0;
  top: calc(100% + 8px);
  padding: 10px;
  z-index: 1;
  height: auto;
  max-height: 300px;
  overflow-y: overlay;
}

.custom-select .items::-webkit-scrollbar {
  width: 0.2em;
}

.custom-select .items::-webkit-scrollbar-track {
  background-color: transparent;
}

.custom-select .items::-webkit-scrollbar-thumb {
  background-color: #c1c5d8;
  border-radius: 9999px;
}

.custom-select .items div {
  color: #fff;
  padding-inline-start: 1em;
  cursor: pointer;
  user-select: none;
  padding: 15px 18px;
  color: #2f434c;
  font-size: 16px;
}

.custom-select .items .loading {
  color: #788e98;
  padding: 1em;
  font-size: 14px;
}

.custom-select .items div:not(:last-child) {
  border-bottom: 1px solid #e0e0df;
}

.custom-select .items div:last-child {
  border-radius: 0 0 8px 8px;
}

.custom-select .items div:first-child {
  border-radius: 8px 8px 0 0;
}

.custom-select .items div:hover,
.custom-select .items div:focus {
  background-color: #f7f8fa;
}

.selectHide {
  display: none;
}

.is-active {
  background-color: #f7f8fa;
}

.error-border {
  border: 1px solid red;
}
</style>
